import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gamepad2, Palette, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const CARDS = [
  {
    to: "/game",
    testid: "funzone-game-card",
    icon: Gamepad2,
    title: "Bubble Pop Challenge",
    text: "Pop as many bubbles as you can in 30 seconds — golden ones are worth 5!",
    bg: "bg-bubz-pink",
    ring: "border-bubz-pink/40",
    rotate: "-rotate-1",
  },
  {
    to: "/coloring",
    testid: "funzone-coloring-card",
    icon: Palette,
    title: "Coloring Sheets",
    text: "Print Bubz & Bubble activity sheets and color them at home.",
    bg: "bg-bubz-sky",
    ring: "border-bubz-sky/40",
    rotate: "rotate-1",
  },
];

export default function FunZone() {
  return (
    <section id="funzone" data-testid="funzone-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.3em] text-bubz-grass">Play time</p>
          <h2 className="font-display text-3xl font-bold leading-tight text-bubz-ink sm:text-4xl lg:text-5xl">
            The <span className="text-bubz-tang">Fun Zone</span>
          </h2>
          <p className="mt-4 max-w-lg text-base font-semibold text-bubz-ink/60 sm:text-lg">
            Games and printables for little fans between episodes.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 sm:grid-cols-2">
          {CARDS.map((c, i) => (
            <Reveal key={c.to} delay={i * 0.12}>
              <motion.div whileHover={{ scale: 1.025, rotate: 0 }} className={c.rotate}>
                <Link
                  to={c.to}
                  data-testid={c.testid}
                  className={`group flex items-center gap-6 rounded-[2.5rem] border-2 ${c.ring} bg-white p-7 shadow-[0_18px_50px_rgba(112,193,255,0.2)] sm:p-9`}
                >
                  <span className={`flex h-20 w-20 shrink-0 items-center justify-center rounded-3xl ${c.bg} shadow-lg`}>
                    <c.icon size={36} className="text-white" />
                  </span>
                  <span className="flex-1">
                    <span className="block font-display text-2xl font-semibold text-bubz-ink">{c.title}</span>
                    <span className="mt-1.5 block text-sm font-semibold leading-relaxed text-bubz-ink/60 sm:text-base">
                      {c.text}
                    </span>
                  </span>
                  <ArrowRight
                    size={26}
                    className="shrink-0 text-bubz-ink/30 transition-transform duration-300 group-hover:translate-x-2 group-hover:text-bubz-ink"
                  />
                </Link>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
